<lms-breadcrumb [crumbs]="[{ label: 'Redis Management', icon: 'glicon-misc', route: '.' }]"></lms-breadcrumb>

<div [ngStyle]="{ width: '40%', float: 'left' }" class="margin-top">
  <gl-button color-primary text="Obtener Info de Redis" (onClick)="getRedisInfo()"></gl-button>
  <pre>
  {{ info }}
  </pre>
</div>

<div [ngStyle]="{ width: '30%', float: 'left' }" class="margin-top">
  <gl-button color-primary text="Obtener keys de Redis" (onClick)="countKeys()"></gl-button>
  <pre>
  {{ count | json }}
  </pre>
</div>

<div [ngStyle]="{ width: '30%', float: 'left' }" class="margin-top">
  <gl-button color-primary text="Obtener keys de Redis (comando KEYS)" (onClick)="countKeys2()"></gl-button>
  <pre>
  {{ count2 | json }}
  </pre>
</div>
